'use strict';

/*
---
description: Mortgage Calculator
authors:
- Anton Burov
license:
- MIT-style license
requires:
- core/1.4.5
*/

var Mcal = new Class({
	Implements: [Events, Options],

	options: {
		cls: 'w_mcal',
		simple: false
	},

	initialize: function initialize(_element, options) {
		this._element = document.id(_element);

		if (this._element) {
			this.setOptions(options);
			this.build();
		}
	},

	build: function build() {
		var self = this;
		var fcls = '.' + this.options.cls;

		this.add_class = this._element.getParent('.w_popup') ? '_popup' : '';

		var _fields = this._fields = this._element.getElements('#asking_price' + this.add_class + ', #m_maintenance' + this.add_class + ', #m_tax' + this.add_class + ', #m_mortgage' + this.add_class + ', #term_years' + this.add_class + ', #term_months' + this.add_class + ', #interest_rate' + this.add_class + ', #down' + this.add_class + ', #downpayment' + this.add_class + ', #total' + this.add_class + ', #mortgage' + this.add_class);

		this.orig_values = [];

		this.values = {
			asking_price: 0,
			m_maintenance: 0,
			m_tax: 0,
			m_mortgage: 0,
			term_years: 0,
			term_months: 0,
			interest_rate: 0,
			down: 0,
			downpayment: 0,
			mortgage: 0,
			total: 0
		};

		var ap = this._element.getElement('#asking_price' + this.add_class),
		    mm = this._element.getElement('#m_maintenance' + this.add_class),
		    mt = this._element.getElement('#m_tax' + this.add_class);

		this.values.asking_price = ap ? ap.get('value').convert_any_to_float() : 0;
		this.values.m_maintenance = mm ? mm.get('value').convert_any_to_float() : 0;
		this.values.m_tax = mt ? mt.get('value').convert_any_to_float() : 0;

		_fields.each(function (_el) {
			self.orig_values.push([_el, _el.get('value') || _el.get('text')]);
		});

		this._element.addEvents({
			'focus:relay(input[type="text"])': function focusRelayInputTypeText(event, _el) {
				if (!_el.getProperty('readonly')) {
					_el.set('value', _el.get('value').convert_any_to_float());
					self.orig_value = _el.get('value');
					_el.select();
				} else {
					if (event && event.stop) {
						event.stop();
					}
				}
			},

			'blur:relay(input[type="text"])': function blurRelayInputTypeText(event, _el) {
				if (!_el.getProperty('readonly')) {
					if (_el.get('value') != self.orig_value) {
						self.calculate(_el);
					} else {
						var prefix = _el.getProperty('dollared') ? '$' : '';
						_el.set('value', prefix + (_el.get('value').add_commas() || '0'));
					}
				}
			},

			'keypress:relay(input[type="text"])': function keypressRelayInputTypeText(event, _el) {
				if (!_el.getProperty('readonly')) {
					if (event.code === 13) {
						if (_el.get('value') !== self.orig_value) {
							self.calculate(_el);
						}

						_el.set('value', _el.get('value').convert_any_to_float());
						self.orig_value = _el.get('value');
					}
				}
			}
		});

		this._button = this._element.getElement(fcls + '_buttons .button');
		this._reset = this._element.getElement(fcls + '_buttons .reset');
		this._cancel = this._element.getElement(fcls + '_buttons .cancel');

		if (this._button) {
			this._button.addEvent('click', function (e) {
				if (e && e.stop) e.stop();
			});
		}

		if (this._reset) {
			this._reset.addEvent('click', function (e) {
				if (e && e.stop) {
					e.stop();
				}

				self.reset();
			});
		}

		this.apply_stored_values();
	},

	calculate: function calculate(_el) {
		this.values.term_years = this._element.getElement('#term_years' + this.add_class).get('value').convert_any_to_float();

		if (this.values.term_years < 5) {
			this.values.term_years = 5;
		}

		this.values.term_months = this.values.term_years * 12;
		this.values.interest_rate = this._element.getElement('#interest_rate' + this.add_class).get('value').convert_any_to_float();

		if (this.values.interest_rate < 0) {
			this.values.interest_rate = 0;
		}

		if (_el.get('id') === 'down' + this.add_class) {
			this.values.down = this._element.getElement('#down' + this.add_class).get('value').convert_any_to_float();

			if (this.values.down < 1) {
				this.values.down = 1;
			} else if (this.values.down > 100) {
				this.values.down = 100;
			}

			this.values.downpayment = (this.values.asking_price / 100 * this.values.down).round();
			this.values.mortgage = (this.values.asking_price - this.values.downpayment).round();
		} else if (_el.get('id') === 'mortgage' + this.add_class) {
			this.values.mortgage = this._element.getElement('#mortgage' + this.add_class).get('value').convert_any_to_float();

			if (this.values.asking_price > 0 && this.values.mortgage > this.values.asking_price) {
				this.values.mortgage = this.values.asking_price;
			} else if (this.values.mortgage < 1) {
				this.values.mortgage = 0;
			}

			this.values.downpayment = (this.values.asking_price - this.values.mortgage).round();
			this.values.down = (this.values.downpayment * 100 / this.values.asking_price).round(1);
		} else {
			var _dp = this._element.getElement('#downpayment' + this.add_class);

			if (_dp) {
				this.values.downpayment = _dp.get('value').convert_any_to_float();

				if (this.values.downpayment < 100000) {
					this.values.downpayment = 100000;
				} else if (this.values.downpayment > this.values.asking_price) {
					this.values.downpayment = this.values.asking_price;
				}

				this.values.mortgage = (this.values.asking_price - this.values.downpayment).round();
			} else {
				this.values.downpayment = 0;
				this.values.mortgage = this._element.getElement('#mortgage' + this.add_class).get('value').convert_any_to_float();
			}

			this.values.down = (this.values.downpayment * 100 / this.values.asking_price).round(1);
		}

		var principle = this.values.mortgage;
		var interest = this.values.interest_rate;

		var interest_rate = interest / 100 / 12;
		var months = this.values.term_months;
		var m_mortgage = (Math.floor(principle * interest_rate / (1 - Math.pow(1 + interest_rate, -1 * months)) * 100) / 100).toFixed(0);

		this.values.m_mortgage = m_mortgage.toFloat() < 1 ? m_mortgage.toFloat().round(1) : m_mortgage.toFloat().round();
		this.values.total = this.values.m_mortgage + this.values.m_maintenance + this.values.m_tax;

		this.set_new_values();

		this.fireEvent('calculate');
	},

	set_new_values: function set_new_values() {
		this.new_values = Object.clone(this.values);

		this.new_values.asking_price = this.new_values.asking_price.toString().add_commas('$') || '$0';
		this.new_values.m_maintenance = this.new_values.m_maintenance.toString().add_commas('$') || '$0';
		this.new_values.m_tax = this.new_values.m_tax.toString().add_commas('$') || '$0';
		this.new_values.m_mortgage = this.new_values.m_mortgage.toString().add_commas('$') || '$0';
		this.new_values.downpayment = this.new_values.downpayment.toString().add_commas('$') || '$0';
		this.new_values.mortgage = this.new_values.mortgage.toString().add_commas('$') || '$0';
		this.new_values.total = this.new_values.total.toString().add_commas('$') || '$0';

		Object.each(this.new_values, function (value, i) {
			var property = 'value';
			var id = '#' + i + this.add_class;
			var _el = this._element.getElement(id);

			if (_el) {
				if (_el.nodeName.toLowerCase() !== 'input') {
					property = 'text';
				}
				_el.set(property, value);
			}
		}.bind(this));
	},

	reset: function reset() {
		this.orig_values.each(function (el) {
			var property = 'value';

			if (el[0].nodeName.toLowerCase() !== 'input') {
				property = 'text';
			}

			el[0].set(property, el[1]);
		});

		Cookie.write('crMcalStoredValues', '');

		this.fireEvent('reset');
	},

	store_values: function store_values() {
		var storage = {};
		storage['down'] = this._element.getElement('#down_popup').get('value');
		storage['term_years'] = this._element.getElement('#term_years_popup').get('value');
		storage['interest_rate'] = this._element.getElement('#interest_rate_popup').get('value');

		Cookie.write('crMcalStoredValues', JSON.stringify(storage));
	},

	apply_stored_values: function apply_stored_values() {
		var cookie = Cookie.read('crMcalStoredValues');
		var _down = this._element.getElement('#down_popup');
		var _terms = this._element.getElement('#term_years_popup');
		var _interest = this._element.getElement('#interest_rate_popup');

		if (cookie) {
			cookie = JSON.parse(cookie, false);

			if (cookie.down) {
				if (_down) {
					_down.set('value', cookie.down);
				}
			}

			if (cookie.term_years) {
				if (_terms) {
					_terms.set('value', cookie.term_years);
				}
			}

			if (cookie.interest_rate) {
				if (_interest) {
					_interest.set('value', cookie.interest_rate);
				}
			}
		}

		if (!_down) return;

		this.calculate(_down);
	}
});
"use strict";

Page.Mgm = new Class({
	Extends: Page,

	build: function build() {
		this.parent();

		Core.stick_last_ads();
	}
});
//# sourceMappingURL=mgm.js.map
